import { getRandomIntInclusive } from '@application/utils';
import { SkeletonBox } from '@presentation/components';
import { PLACEHOLDER_IMAGE_USER } from '@presentation/constants';
import { useMemo } from 'react';
import * as Styled from '../styled';

export const Skeleton = () => {
  const skeletons = useMemo(() => {
    return {
      title: { width: getRandomIntInclusive(150, 220), height: 40 },
      booking: {
        pro: {
          name: { width: getRandomIntInclusive(70, 90), height: 20, margin: 2 },
          email: { width: getRandomIntInclusive(70, 90), height: 20, margin: 2 },
          phone: { width: getRandomIntInclusive(70, 90), height: 20, margin: 2 }
        },
        animals: Array(getRandomIntInclusive(2, 3))
          .fill(undefined)
          .map(() => ({
            name: { width: getRandomIntInclusive(70, 90), height: 20, margin: 2 },
            gender: { width: getRandomIntInclusive(70, 90), height: 20, margin: 2 },
            birthday: { width: getRandomIntInclusive(70, 90), height: 20, margin: 2 },
          })),
      }
    };
  }, []);

  return (
    <Styled.Wrapper>
      <Styled.Header active>
        <SkeletonBox style={{ ...skeletons.title }} />
      </Styled.Header>

      <Styled.Section>
        <Styled.Image src={PLACEHOLDER_IMAGE_USER} />
        <Styled.SectionContent>
          <div><SkeletonBox style={{ ...skeletons.booking.pro.name }} /></div>
          <Styled.Text><SkeletonBox style={{ ...skeletons.booking.pro.email }} /></Styled.Text>
          <Styled.Text><SkeletonBox style={{ ...skeletons.booking.pro.phone }} /></Styled.Text>
        </Styled.SectionContent>
      </Styled.Section>

      {skeletons.booking.animals.map((animal, index) => (
        <Styled.Section key={index}>
          <Styled.Image src={PLACEHOLDER_IMAGE_USER} />
          <Styled.SectionContent>
            <SkeletonBox style={{ ...animal.name }} />
            <Styled.Text>
              <SkeletonBox style={{ ...animal.gender }} />
              <SkeletonBox style={{ ...animal.birthday }} />
            </Styled.Text>
          </Styled.SectionContent>
        </Styled.Section>
      ))}
    </Styled.Wrapper>
  );
};
